export const meta: BlockMeta = {
  title: "Project Marquee",
  tags: ["#page"],
}

import { Button } from "@components/atoms/Button"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Appear } from "@components/motion/Appear"
import { defineBlock, EditableText } from "eddev/blocks"
import Marquee from "react-fast-marquee"
import { Fragment } from "react"
import { Link, useHydrating } from "eddev/routing"

export default defineBlock("content/project-marquee", (props) => {
  const projects = props.projects || props.allProjects?.nodes || []
  const hydrating = useHydrating()

  return (
    <Appear className="w-full block-spacing block-padding relative flex flex-col gap-7">
      <div className="content-sized absolute left-1/2 -translate-x-1/2 top-0 w-full h-[1px] bg-concrete md:hidden" />
      <div className="content-sized">
        <EditableText
          as="h3"
          store="title"
          className="type-desktop-headings-heading-xl md:type-desktop-headings-heading-xxl"
          placeholder="248 projects, worldwide."
          defaultValue="248 projects, worldwide."
        />
      </div>
      {!hydrating && (
        <Marquee gradient={false} autoFill pauseOnHover speed={40}>
          {projects?.map(
            (project, index) =>
              project?.uri && (
                <Link key={index} href={project.uri}>
                  {project.projectHeader?.featuredImage?.mediaItemUrl && (
                    <ResponsiveImage
                      {...project.projectHeader.featuredImage}
                      className="ml-2 w-auto h-projectMarqueeImgH"
                    />
                  )}
                </Link>
              ),
          )}
        </Marquee>
      )}
      <div className="content-sized">
        <Button href="/projects">View All Projects</Button>
      </div>
    </Appear>
  )
})
